import { Severity, IconErrorColor, Grey } from '../constants';

export const getTopKeyCardStyles = (_components, { palette }) => ({
  TopKeyCardGroup: {
    marginLeft: -8,
    marginRight: -8,
  },
  AmountNodeInfo: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'end',
  },
  AmountNodeValueNode: {
    marginRight: 10,
  },
  AmountNodeValue: {
    fontSize: 28,
    fontWeight: 600,
    lineHeight: '36px',
  },
  AmountNodeSuffix: {
    fontSize: 14,
    fontWeight: 600,
    marginLeft: 2,
  },
  AmountHint: {
    fontSize: 14,
  },
  ItemName: {
    fontSize: 14,
    lineHeight: '20px',
  },
  MessageItem: {
    fontSize: 12,
    lineHeight: '16px',
  },
  [`Icon-Severity-${Severity.Error}`]: {
    color: IconErrorColor,
  },
  [`Icon-Severity-${Severity.Warning}`]: {
    color: palette.orange,
  },
  CampaignEditLink: {
    marginRight: 16,
  },
  CampaignSharedIcon: {
    marginLeft: 4,
    fontSize: 14,
  },
});

export const getThresholdProgressBarStyles = (_components, { palette }) => ({
  Container: {
    position: 'relative',
    width: 209,
    height: 4,
    marginTop: 8,
  },
  Bar: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    background: ({ percentage }) => {
      const progress = 100 * percentage;
      return `linear-gradient(to right, ${palette.themePrimary} ${progress}%, ${Grey} ${progress}%)`;
    },
    borderRadius: 2,
  },
});

export const getInsertionOrderCardStyles = () => ({
  Item: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: 12,
  },
  ItemValue: {
    fontSize: 28,
    fontWeight: 600,
    lineHeight: '36px',
  },
  NoActiveIO: {
    marginTop: 5,
  },
  NoActiveName: {
    fontSize: 16,
    fontWeight: 600,
    lineHeight: '22px',
    marginBottom: 8,
  },
  NoActiveMessageItem: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    lineHeight: '20px',
    marginBottom: 4,
  },
  NoActiveMessageItemPrefix: {
    marginRight: 4,
  },
  FontSize14: {
    fontSize: '14px !important',
  },
});

export const getAlertMessageStyles = (_components, { palette }) => ({
  MessageText: {
    marginRight: 8,
  },
  MessageBar: {
    marginTop: 8,
    '& .ms-MessageBar-content': {
      alignItems: 'center',
    },
  },
  [`Icon-Severity-${Severity.Error}`]: {
    color: IconErrorColor,
  },

  [`Icon-Severity-${Severity.Warning}`]: {
    color: palette.orange,
  },
});
